// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vui-queryStringInput input{padding-right:30px !important;text-overflow:ellipsis}`, "",{"version":3,"sources":["webpack://./component/input/queryStringInput.scss"],"names":[],"mappings":"AACE,4BACE,6BAAA,CACA,sBAAA","sourcesContent":[".vui-queryStringInput {\n  input {\n    padding-right: 30px !important;\n    text-overflow: ellipsis;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
